import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import AddIcon from '@mui/icons-material/Add';
import { CustomFilterV2, TableV2 } from '../../../components/v2';
import * as actionsUsuarioDocumentos from '../../../store/usuarioDocumento/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as Roles from '../../../constants/role';
import Formulario from './Formulario';

const validade = (row) => {
  if (row.possuiValidade) return `Válido por ${row.validadeEmAnos} anos`;
  return '-';
};

const UsuarioDocumentoCertificadoV2 = ({ deleteUsuarioDocumento, authData }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [localFilter, setLocalFilter] = useState({});
  const [reload, setReload] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);

  const isAdmin = authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  const apiFilter = useMemo(() => {
    if (isAdmin) return localFilter;
    return { ...localFilter, usuarioAtivo: true };
  }, [localFilter, isAdmin]);

  const onEdit = (rowId) => {
    setId(rowId);
    setOpen(true);
  };

  const onAdd = () => {
    setId(null);
    setOpen(true);
  };

  const onClose = (isSave) => {
    if (isSave) setReload((current) => !current);
    setOpen(false);
    setId(null);
  };

  const onDelete = (rowId) => {
    deleteUsuarioDocumento(rowId, () => setReload((current) => !current));
  };

  const headerActions = isAdmin
    ? [
        {
          label: 'Novo',
          onClick: onAdd,
          startIcon: <AddIcon />,
          variant: 'contained',
        },
      ]
    : [];

  const columns = [
    {
      field: 'nome',
      headerName: 'Nome',
      flex: 1.2,
      minWidth: 200,
    },
    {
      field: 'tipo',
      headerName: 'Tipo',
      flex: 0.6,
      minWidth: 120,
      valueGetter: (_, row) => (row.tipo === 'DOCUMENTO' ? 'Documento' : 'Certificado'),
    },
    {
      field: 'validade',
      headerName: 'Validade',
      flex: 0.7,
      minWidth: 140,
      valueGetter: (_, row) => validade(row),
    },
    {
      field: 'descricao',
      headerName: 'Descrição',
      flex: 0.9,
      minWidth: 120,
    },
  ];

  return (
    <Box>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
          sx={{ pr: 2 }}
        >
          <Typography variant="h4">Documentos e Certificados</Typography>
          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <TableV2
          useApi
          fetchUrl="usuario-documentos/filtro"
          paginationUrl="/v2/usuarios-documentos"
          filterData={apiFilter}
          refreshKey={reload}
          columns={columns}
          pageSize={15}
          headerActions={headerActions}
          onEdit={isAdmin ? onEdit : undefined}
          onView={!isAdmin ? onEdit : undefined}
          onDelete={isAdmin ? onDelete : undefined}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          appliedFilter={localFilter}
          fields={[
            { field: 'useTipoUsuarioDocumento', md: 4, xs: 12 },
            { field: 'usePossuiValidade', md: 3, xs: 6 },
            { field: 'useValidade', md: 3, xs: 6 },
          ]}
          onFilter={(filterData) => {
            setLocalFilter(filterData);
            setOpenFilter(false);
          }}
        />
      </Stack>

      <Formulario id={id} open={open} onClose={onClose} readOnly={!isAdmin} />
    </Box>
  );
};

const mapStateToProps = (state) => ({
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { deleteUsuarioDocumento: actionsUsuarioDocumentos.deleteUsuarioDocumento },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UsuarioDocumentoCertificadoV2));
